import {
  WarehouseDispenseMode,
  WarehouseControlledCategory,
  WarehouseProductKind,
  WarehouseQuantityMeasure,
  WarehouseUnit,
  WarehouseVatRate,
} from 'woofwoof-api';

export const PRODUCT_KINDS: WarehouseProductKind[] = ['DRUG', 'NON_DRUG'];
export const WAREHOUSE_UNITS: WarehouseUnit[] = [
  'TABLET',
  'CAPSULE',
  'BLISTER',
  'ML',
  'G',
  'PIECE',
  'SACHET',
  'AMPOULE',
  'VIAL',
  'PIPETTE',
  'DOSE',
  'OTHER',
];
export const VAT_RATES: WarehouseVatRate[] = ['23', '8', '5', '0', 'ZW'];
export const CONTROLLED_CATEGORIES: WarehouseControlledCategory[] = [
  'I-N',
  'II-N',
  'II-P',
  'III-P',
  'IV-P',
];
export const QUANTITY_MEASURES: WarehouseQuantityMeasure[] = [
  'PACKAGE',
  'UNIT',
];

/** "Wydawanie opiekunowi" (#692 rev B); a drug never set is PACKAGES. */
export const DISPENSE_MODES: WarehouseDispenseMode[] = ['PACKAGES', 'UNITS'];
